import React from 'react';
import { ThemeProvider } from 'styled-components';
import { useMediaQuery } from 'react-responsive';
import theme from '../../../../../assets/stylesheets/_settings.global.scss';
import Header from './header';

const HeaderWrapper = React.forwardRef((props, ref) => {
  const {
    breakpointSmallMax: sMax,
    breakpointLargeMin: lMin,
    breakpointLargeMax: lMax,
  } = theme;
  const isBumpView = useMediaQuery({
    query: `(max-width: ${lMax}) and (min-width: ${lMin}), (max-width: ${sMax})`,
  });
  const isMobile = useMediaQuery({ query: `(max-width: ${theme.breakpointMediumMax})` });
  const hdrRef = React.useRef();

  React.useImperativeHandle(ref, () => ({
    update: d => hdrRef && hdrRef.current && hdrRef.current.update(d),
  }));

  return (
    <ThemeProvider theme={{ ...theme, isBumpView, isMobile }}>
      <Header {...props} ref={hdrRef} />
    </ThemeProvider>
  );
});

HeaderWrapper.displayName = 'HeaderWrapper';

export default HeaderWrapper;
